module.exports = __webpack_public_path__ + "img/P150T_weapon_1.7fa2aef7.png";